import React from "react";
import PropTypes from "prop-types";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const LeadPagination = ({ totalPages, totalRecords, currentPage, setCurrentPage, recordsPerPage }) => {
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  // Check if next button should be disabled based on total records
  const shouldDisableNext = totalRecords <= recordsPerPage || currentPage >= totalPages;

  const renderPageNumbers = () => {
    let pages = [];
    let startPage = 1;
    let endPage = totalPages;

    if (totalPages > 5) {
      startPage = Math.max(currentPage - 2, 1);
      endPage = Math.min(currentPage + 2, totalPages);

      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 2 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => handlePageClick(i)}
          className={`px-[10px] md:px-[20px] md:py-[10px] py-[5px] rounded-full ${
            currentPage === i
              ? "bg-[#FAE3AC]"
              : "text-gray-400 hover:bg-[#ececec] hover:text-black"
          }`}
        >
          {i}
        </button>
      );
    }

    if (totalPages > 5) {
      if (startPage > 1) {
        pages.unshift(
          <span key="start-ellipsis" className="p-2">
            ...
          </span>
        );
        pages.unshift(
          <button
            key={1}
            onClick={() => handlePageClick(1)}
            className={`px-[20px] py-[10px] rounded-full ${
              currentPage === 1
                ? "bg-[#fae3ac]"
                : "text-gray-400 hover:bg-[#ededed] hover:text-black"
            }`}
          >
            1
          </button>
        );
      }

      if (endPage < totalPages) {
        pages.push(
          <span key="end-ellipsis" className="px-[20px] py-[10px]">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageClick(totalPages)}
            className={`px-[20px] py-[10px] rounded-full ${
              currentPage === totalPages
                ? "bg-[#FAE3AC]"
                : "text-gray-400 hover:bg-[#ececec] hover:text-black"
            }`}
          >
            {totalPages}
          </button>
        );
      }
    }

    return pages;
  };

  return (
    <div className="flex items-center justify-center space-x-1 media_class_pagination py-[30px] bg-white">
      <button
        className={`md:px-[15px] px-[4px] py-[5px] flex items-center gap-2 hover:bg-[#ececec] rounded-full ${
          currentPage === 1 ? "text-gray-400 cursor-not-allowed" : "text-black"
        }`}
        onClick={handlePrevious}
        disabled={currentPage === 1}
      >
        <IoIosArrowBack
          className={`${currentPage === 1 ? "text-gray-400 " : "text-black"}`}
        />
        Previous
      </button>
      {renderPageNumbers()}
      <button
        className={`md:px-[15px] px-[4px] py-[5px] flex items-center gap-2 hover:bg-[#ececec] rounded-full ${
          shouldDisableNext ? "text-gray-400 cursor-not-allowed" : "text-black"
        }`}
        onClick={handleNext}
        disabled={shouldDisableNext}
      >
        Next
        <IoIosArrowForward
          className={`${
            shouldDisableNext ? "text-gray-400" : "text-black"
          }`}
        />
      </button>
    </div>
  );
};

LeadPagination.propTypes = {
  totalPages: PropTypes.number.isRequired,
  totalRecords: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  recordsPerPage: PropTypes.number.isRequired,
};

export default LeadPagination;
